import {t} from '../../../../common/getTranslations';
import {showSimpleDialog} from '../../../../dialog/simpleDialogHandler';
import {logoutPageweb} from '../../../../domain/login/util/logoutPageweb';

export function cancelLoginAgreement({
  isMobile,
  shouldCheckRequiredAgreement,
}: {
  isMobile: boolean;
  shouldCheckRequiredAgreement: boolean;
}) {
  if (shouldCheckRequiredAgreement) {
    showSimpleDialog({
      title: t('alert_message_agreement_guide_toast'),
      isMobile,
      cancelButton: {
        type: 'label',
        text: t('common_cancel_button'),
      },
      okButton: {
        type: 'label',
        text: t('common_confirm_button'),
        onClick: () =>
          logoutPageweb({
            success: () => window.location.replace('/'),
          }),
      },
    });
  } else {
    window.location.replace('/');
  }
}
